import { createSelector } from 'reselect';

export const getSearchImpersonationResults = ({ impersonation }) => impersonation.impersonationAgentSearchResults;

export const getAgentSelected = ({ agent }) => agent.agentSelected;

export const getAllowedUsers = ({ impersonation }) => impersonation?.allowedUsers;

export const selectStatus = ({ impersonation }) => impersonation?.status;

export const selectIsImpersonating = ({ impersonation }) => impersonation?.isImpersonating;

export const getImpersonationTargets = ({ impersonation }) => impersonation?.impersonationTargets;

export const getImpersonationStateChange = ({ impersonation }) => impersonation?.impersonationStateChange;

export const getImpersonationStatus = createSelector(
  selectStatus,
  impersonationStatus => {
    const structure = {};

    if (impersonationStatus?.ImpersonationActive) {
      structure.memberMlsId = impersonationStatus?.ImposterName;
      structure.memberFullName = impersonationStatus?.memberFullName;
      structure.memberAOR = impersonationStatus?.memberAOR;
      structure.memberUniqueID = impersonationStatus?.memberUniqueID;
    }
    structure.ImpersonationActive = impersonationStatus?.ImpersonationActive;
    return structure;
  },
);

// retrieves impersonated user by check that impersonation is active and status ID matches the selected user
// export const getImpersonatedUser = createSelector(
//   selectStatus,
//   selectIsImpersonating,
//   (status, target) => {
//     const structure = {};
//     if (status?.ImpersonationActive && target
//       && target?.memberMlsId.toUpperCase() === status.ImposterName) {

//     }
//   },
// );
